import { useState } from "react";
import { RecommendationUrl } from "../constants";

const initProducts = (data) => {
  let categoryIdCounter = 1;
  // Flatten API response
  const remappedData = Object.entries(data).flatMap(([category, items]) => {
    // Skip categories that are empty or have no valid name
    if (!category || category.trim() === "") return [];

    // Filter out products with empty or missing brand names
    const validItems = items.filter(
      (product) => product.brand && product.brand.trim() !== "",
    );

    // If there are no valid products in this category, skip it
    if (validItems.length === 0) return [];

    // Take only the first valid product for this category
    const product = validItems[0];

    return [
      {
        ...product,
        category: category.trim(),
        brand: product.brand.trim(),
        selected: false,
        id: categoryIdCounter++,
      },
    ];
  });
  return remappedData;
};

export const useRecommendedProducts = () => {
  const [recommendedProducts, setRecommendedProducts] = useState(null);

  const resetRecommendedProducts = () => {
    setRecommendedProducts(null);
  };

  const fetchRecommendedProducts = async (apiToken, lng) => {
    try {
      const response = await fetch(`${RecommendationUrl}?lng=${lng}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        method: ["GET"],
      });
      if (response.ok) {
        const jsonProducts = await response.json();
        setRecommendedProducts(initProducts(jsonProducts));
        return true;
      } else {
        throw new Error("Failed to fetch!");
      }
    } catch (error) {
      // Leaving it empty as no message is displayed
      setRecommendedProducts([]);
      return false;
    }
  };

  const updateProductsInfo = (newProductsInfo) => {
    setRecommendedProducts(newProductsInfo);
  };

  return {
    recommendedProducts,
    updateProductsInfo,
    fetchRecommendedProducts,
    resetRecommendedProducts,
  };
};
